// @flow

export function createMarkup(html: string): Object {
    return { __html: html };
}
